import { BaseEntity } from "./base-entity";

export class Media extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string = null;
    KratakOpis: string = null;
    DetaljanOpis: string = null;
    VideoId: string = null;
    ActionLabel: string = null;
    ActionUrl: string = null;
    MediaGenericName: string = null;
    ButtonGenericName: string = null;
    PrikaziTutorijal: boolean = null;
    MediaInfoId: number = null;

    Deserialize(input: any): this {
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.KratakOpis = input.KratakOpis;
        this.DetaljanOpis = input.DetaljanOpis;
        this.VideoId = input.VideoId;
        this.ActionLabel = input.ActionLabel;
        this.ActionUrl = input.ActionUrl;
        this.MediaGenericName = input.MediaGenericName;
        this.ButtonGenericName = input.ButtonGenericName;
        this.PrikaziTutorijal = input.PrikaziTutorijal;
        this.MediaInfoId = input.MediaInfoId;

        return this;
    }
}